import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Slider from "../components/home/Slider";
import InformationSection from "../components/home/InformationSection";
import StatsCounter from "../components/home/StatsCounter";
import KnowledgeSection from "../components/home/KnowledgeSection";
import VideoSection from "../components/home/VideoSection";
import NewsSection from "../components/home/NewsSection";
import CalendarSection from "../components/home/CalendarSection";
import ProjectSection from "../components/home/ProjectSection"; // เพิ่ม import
import { motion } from "framer-motion";
import toast from "react-hot-toast";

const HomePage = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>งานบริการวิชาการ | คลังปัญญา มหาวิทยาลัยราชภัฏศรีสะเกษ</title>
        <meta
          name="description"
          content="ระบบคลังปัญญาและบริหารจัดการงานบริการวิชาการ มหาวิทยาลัยราชภัฏศรีสะเกษ"
        />
      </Helmet>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Slider />
        <StatsCounter />
        <ProjectSection /> {/* เพิ่ม section นี้ */}
        <KnowledgeSection />
        <VideoSection />
        <NewsSection />
        <InformationSection />
        <CalendarSection />
      </motion.div>
    </>
  );
};

export default HomePage;
